var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10179 16.669H3.33105V12.8983C3.33105 12.5118 3.48453 12.1411 3.7579 11.8679L12.7016 2.92415C12.9748 2.65041 13.3457 2.49658 13.7325 2.49658C14.1192 2.49658 14.4901 2.65041 14.7633 2.92415L17.0759 5.23678C17.3497 5.51 17.5035 5.88087 17.5035 6.26763C17.5035 6.65438 17.3497 7.02526 17.0759 7.29847L8.13222 16.2422C7.85878 16.5153 7.48823 16.6688 7.10179 16.669Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 4.99756L15.0024 9.16596",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49902 12.501L10.0001 10",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/pen-edit.b564416ca491801dc74d0ffa9420ea6d.svg";
export { ForwardRef as ReactComponent };